module.exports = __webpack_public_path__ + "img/homepage_banner_outlined_2.00705417.svg";